import { render, staticRenderFns } from "./freeCancellation.vue?vue&type=template&id=e4cd4908&scoped=true"
import script from "./freeCancellation.vue?vue&type=script&lang=js"
export * from "./freeCancellation.vue?vue&type=script&lang=js"
import style0 from "./freeCancellation.vue?vue&type=style&index=0&id=e4cd4908&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4cd4908",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/var/www/tubber-new/components/global/v/button.vue').default})
